import { useSelector } from 'react-redux';

export const useIsPreliminaryAuth = () => (
  useSelector(({ authentication }) => !!(authentication?.loggedIn && authentication.user))
);
